<template>
  <div>

    <v-app-bar left app>


        <v-btn icon v-if="selection.return==='1'">

          <a @click="$router.go(-1)">
            <v-icon color="grey">mdi-chevron-left</v-icon>
          </a>
        </v-btn>


        <v-btn
                v-else-if="selection.return==='0'"
                icon
        >
          <a href="javascript: history.go(-1)">
          <v-icon color="grey">mdi-close</v-icon>
          </a>
        </v-btn>


      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon v-if="selection.icons" @click="sheet = true">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>

    </v-app-bar>


      <v-bottom-sheet v-model="sheet">

          <v-list>
              <v-subheader>MENÚ</v-subheader>
              <v-list-item
                      v-for="tile in selection.icons"
                      :key="tile.id"
                      @click="sheet = false"

              >

                  <a v-if="tile.href" :href="'#/'+tile.href">

                    <v-list-item-title>{{ tile.text }} </v-list-item-title>
                  </a>

                  <button v-else v-on:click="clicksend(tile.id, tile.method)">

                      <v-list-item-title>{{ tile.text }} </v-list-item-title>
                  </button>

              </v-list-item>
          </v-list>
      </v-bottom-sheet>

      <div>
          <v-row justify="center">
              <v-dialog
                      v-model="dialog"
                      persistent
                      max-width="290"
              >

                  <v-card>
                      <p class="title-box" style="text-align:center; text-transform: uppercase;">
                          {{action}}
                      </p>
                      <v-card-text>¿Estás seguro de <b>{{action}}</b> este elemento?</v-card-text>

                      <div v-if="action==='archivar'">
                          <!--v-select--
                                  v-model="infoform.type"
                                  class="form-group"
                                  color="orange"
                                  :items="optionsType"
                                  label="Motivo*"
                                  data-vv-name="infoform.type"
                                  required
                          ></v-select-->

                          <v-select
                                  v-model="infoform.type"
                                  class="form-group"
                                  color="orange"
                                  :items="optionsType"
                                  item-value="[value]"
                                  item-text="[text]"
                                  label="Motivo*"
                                  data-vv-name="infoform.type"
                                  required
                          ></v-select>



                      </div>
                      <v-card-actions>
                          <v-spacer></v-spacer>

                          <!--v-select
                                  v-model="infoform.frame_breeding"
                                  class="form-group subcheck"
                                  color="amber darken-2"
                                  label="Cría"
                                  :items="optionsAlza"
                          ></v-select-->


                          <v-btn
                                  color="grey darken-1"
                                  text
                                  @click="dialog = false; agree = ''"
                          >
                              Cancelar
                          </v-btn>
                          <v-btn
                                  color="green darken-1"
                                  text
                                  @click="deleteElement()"
                          >
                              {{action}}
                          </v-btn>
                      </v-card-actions>
                  </v-card>
              </v-dialog>
          </v-row>
      </div>


  </div>
</template>

<script>
import axios from "axios";

export default {
    props: ['selection','title','action'],
    data() {
        return {
        sheet: false,
      /*  selection: [],*/

        agree:'',
        method:'',
        dialog:false,

       /* optionsType: [
              { text: 'Vacía', value: 'vacia' },
              { text: 'Polilla', value: 'polilla' },
              { text: 'Enfermedad', value: 'enfermedad' },
              { text: 'Pillaje', value: 'pillaje' }
            ],
            */
            optionsType: [],


            infoform: {
                type: '',
             }

    }
    },

    methods:{

        clicksend(id, method) {
            var that = this
            that.agree = id
            that.method = method
            that.dialog = true
        },
        deleteElement() {


           axios.delete('https://appws.panimiel.com/new/index.php/api/'+this.method+'/'+this.agree+'/'+this.infoform.type)
              .then(response => {
document.getElementById("content").innerHTML="<div class='card'><a href='#' class='btn btn-yellow' onClick='window.history.back()'>Volver</a><br/><br/><p style='text-align:center'>"+response.data+"</p></div>";

            }).catch((error) => {

                if (error.response.status != 500){
                    alert(error.response.data)
                }else{
                    alert('Error, no ha sido posible realizar la operación.')
                }

             })


            this.dialog = ''

        }

    },
    created() {

        var that = this
       axios.get("https://appws.panimiel.com/new/index.php/api/colmena/status_archived/").then(function (response) {
              that.optionsType = response.data;
            })


        /* that.optionsType = optionsType.data
         alert(that.optionsType)*/


    }

}
</script>
